import { connect } from "react-redux";
import Banner from "./components/Banner";
import Avatar from "../../../components/Avatar";
import { Name } from "./styles";
import { UserDto } from "../../../types/user.dto";
import { useLayout } from "../../../provider/LayoutProvider";
import React, { useEffect } from "react";
import Grid from "../../../components/Grid";
import ChangePassword from "./components/ChangePassword";
import ChangeInformation from "./components/ChangeInformation";
import MfaSection from "./components/MfaSection";
import { AuthContext } from "../../../provider/AuthProvider";

interface ComponentProps {
  user: UserDto;
}

const Component = ({ user }: ComponentProps) => {
  const { layout, setLayout } = useLayout();
  const { passwordExpired, isFirstLogin } = React.useContext(AuthContext);

  useEffect(() => {
    setLayout({
      ...layout,
      showSubHeader: false,
      fullFillContent: true,
    });
  }, []);

  return (
    <>
      <Banner />

      <Grid.Container>
        <Grid.Row>
          <Grid.Col offset={{ lg: 1 }} sm={10}>
            {passwordExpired && (
              <Grid.Row>
                <Grid.Col sm={12}>
                  <div
                    style={{
                      backgroundColor: "#ff4d4f",
                      color: "white",
                      padding: "20px",
                      borderRadius: "8px",
                      marginBottom: "40px",
                      marginTop: "20px",
                      boxShadow: "0 4px 12px rgba(255, 77, 79, 0.3)",
                    }}
                  >
                    <h3 style={{ margin: 0, color: "white" }}>
                      {isFirstLogin
                        ? "¡Bienvenido! Por seguridad, debes establecer una contraseña."
                        : "Tu contraseña ha expirado."}
                    </h3>
                    <p style={{ margin: "10px 0 0 0" }}>
                      Por favor, actualiza tu contraseña para continuar utilizando el
                      sistema. Las demás funciones estarán deshabilitadas hasta que
                      realices el cambio.
                    </p>
                  </div>
                </Grid.Col>
              </Grid.Row>
            )}
            <Grid.Row>
              <Grid.Col sm={3}>
                <Avatar
                  size="xbig"
                  style={{ marginTop: passwordExpired ? "20px" : "-80px" }}
                />

                <Name>
                  {user?.nombre}, {user?.apellido}
                </Name>
                <p>{user?.email}</p>
              </Grid.Col>

              <Grid.Col sm={6}>
                <div style={{ height: "54px" }} />
                {!passwordExpired && <ChangeInformation />}
                {!passwordExpired && <div style={{ height: "24px" }} />}
                <ChangePassword />
                <div style={{ height: "24px" }} />
                <MfaSection />
                <div style={{ height: "54px" }} />
              </Grid.Col>

              <Grid.Col sm={3}>
                <></>
              </Grid.Col>
            </Grid.Row>
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </>
  );
};

const states = ({ userStore }) => {
  const { data: user } = userStore.information;

  return {
    user,
  };
};

export default connect(states)(Component);
